import { render } from "./BannerMulti.vue?vue&type=template&id=5d0cc7bb"
import script from "./BannerMulti.vue?vue&type=script&lang=js"
export * from "./BannerMulti.vue?vue&type=script&lang=js"

import exportComponent from "/Users/n0m4dz/workspace/projects/seeroo-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__